import { Injectable } from '@angular/core';
import { ConfigService } from '@core/config.service';
import { LoggerService } from '@wdpr/ra-angular-logger';
import { WindowSizeService } from '@app/shared/services/window-size/window-size.service';
import { WindowSizeEnum } from '@app/shared/services/window-size/window-size.enum';
import { AbsTrimmerPipe } from '@app/pipes/abs-trimmer.pipe';

@Injectable({
    providedIn: 'root'
})
export class RedirectionService {
    constructor(
        private windowSizeService: WindowSizeService,
        private config: ConfigService,
        private loggerService: LoggerService
    ) {}

    redirectToUrl(event, isOnFullscreen: boolean, getCtaUrl?: () => string): boolean {
        if (!isOnFullscreen) {
            // avoid redirection if it's media-engine autoplay play/pause button
            if (!event.target.classList?.contains('me-video-play-pause')) {
                window.location.href = getCtaUrl();
            }

            return false;
        } else {
            // If the user is on fullscreen, we don't want to redirect them to the CTA URL
            // me-fullscreen-exit is the class that is added to the media-engine close fullscreen button
            return !event.target.classList?.contains('me-fullscreen-exit');
        }
    }

    getCtaUrl(ctasMobile: object[], ctasDesktop: object[]): string {
        if (this.windowSizeService.getDevice() === WindowSizeEnum.Mobile) {
            return ctasMobile[1]['ctaURL'];
        } else {
            return ctasDesktop[1]['ctaURL'];
        }
    }

    getCtaUrlTransformed(ctasMobile: object[], ctasDesktop: object[]): string {
        const ctaUrl = this.getCtaUrl(ctasMobile, ctasDesktop);
        const absTrimmerPipe = new AbsTrimmerPipe(this.loggerService, this.config);

        return absTrimmerPipe.transform(ctaUrl, true, true);
    }
}
